import { useEffect } from 'react';
import { uiModel } from 'entities/ui';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import { useLazyIndicatorsQuery } from '../../../app/services/edpApiV1/viewer';
import { useAppDispatch, useAppSelector } from '../../../app/store';

/**
 * @hook обновление индикаторов, после обновления данных
 */

export const useIndicators = (isSuccess: boolean, isFetching: boolean, isPull = true) => {
  const dispatch = useAppDispatch();
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const [indicatorsTrigger] = useLazyIndicatorsQuery();
  // подписываемся на обновление индикаторов, после обновления списка неявок
  useEffect(() => {
    // отключаем пуллинг запроса индикаторов
    if (!isPull) {
      dispatch(uiModel.Indicators.actions.setIsPoll(isPull));
    }

    if (isSuccess && !isFetching) indicatorsTrigger({ allAvailableOrganizations });

    return () => {
      if (!isPull) {
        dispatch(uiModel.Indicators.actions.setIsPoll(true));
      }
    };
  }, [isSuccess, isFetching, isPull, dispatch, indicatorsTrigger, allAvailableOrganizations]);
};
